<template>
    <div :class="fixed ? 'emoji-wallpaper' : 'emoji-wallpaper-notfixed'">
        <div v-for="(row, rowIndex) in numberOfRows" :key="rowIndex" class="emoji-row">
            <div v-for="(col, colIndex) in numberOfColumns" :key="colIndex" :style="getEmojiStyle(rowIndex, colIndex)" class="emoji-label">
                {{ emoji }}
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "EmojiWallpaper",
    props: {
        emoji: {
            type: String,
            default: "🥳",
        },
        emojiSize: {
            type: Number,
            default: 50,
        },
        pixelsPerRow: {
            type: Number,
            default: 100,
        },
        fixed: {
            type: Boolean,
            default: false,
        },
        maxEmojisPerRow: {
            type: Number,
            default: 10, // Set a default value according to your needs
        },
    },
    data() {
        return {
            windowSize: {
                width: window.innerWidth,
                height: window.innerHeight,
            },
        };
    },
    computed: {
        numberOfRows(): number {
            return Math.ceil(this.windowSize.height / this.pixelsPerRow);
        },
        numberOfColumns(): number {
            const columns = Math.ceil(this.windowSize.width / this.pixelsPerRow);
            return Math.min(columns, this.maxEmojisPerRow);
        },
    },
    methods: {
        getEmojiStyle(row: number) {
            return {
                fontSize: `${this.emojiSize}px`,
                lineHeight: `${this.pixelsPerRow}px`,
                transform: `translateX(${row % 2 === 0 ? this.pixelsPerRow / 2 : 0}px)`,
            };
        },
        handleResize() {
            this.windowSize = {
                width: window.innerWidth,
                height: window.innerHeight,
            };
        },
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
});
</script>

<style scoped>
.emoji-wallpaper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 1;
}

.emoji-wallpaper-notfixed {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.emoji-row {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
}

.emoji-label {
    display: inline-block;
    text-align: center;
    white-space: nowrap;
}
</style>
